import React from 'react';

import CustomSelect from 'components/elements/CustomSelect';

const LabeledCustomSelect = ({ required, ...rest }) => {
  return <CustomSelect {...rest} />;
};

export default LabeledCustomSelect;
